import React from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";

export default function Unternehmensnachfolge() {
	return (
		<>
			<div className="beratung_cont" id="m_and_a">
				<HelmetProvider>
					<Helmet>
						<title>Beratung bei der Unternehmensnachfolge</title>
						<meta
							name="description"
							content="Beratung bei der Unternehmensnachfolge"
						/>
						<meta
							name="keywords"
							content="Unternehmensnachfolge, Assets , Feingeist, Berlin"
						/>
					</Helmet>
				</HelmetProvider>
				<h1>Beratung bei der Unternehmensnachfolge</h1>
				<h2>Ein Lebenswerk wird nur einmal weitergegeben</h2>
				<p>
					Die Feingeist Beratung begleitet Sie die letzte Entscheidung
					bestmöglich als Unternehmer zu treffen.
				</p>
				<p>Ihre Vorteile:</p>
				<ul className="typeset-u-list">
					<li>Langfristiger vertrauensvoller Beratungsansatz</li>
					<li>Ganzheitlicher Blick auf die Übergabe</li>
					<li>Optimierung des Lebenswerks vor Beginn des Verkaufsprozesses</li>
					<li>
						Unterstützung bei der Kommunikation nach innen (z.B. Mitarbeiter)
						und außen (z.B. Kunden)
					</li>
				</ul>
				<p>
					Insbesondere die Gründergeneration, die in den Ruhestand gehen möchte,
					steht häufig vor der Herausforderung ihr Lebenswerk in vertrauensvolle
					Hände zu übergeben.
				</p>
				<p>
					Aus Sicht des Verkäufers sind neben den steuerlichen und rechtlichen
					Aspekten weitere Punkte bei einer Unternehmensnachfolge zu beachten:
				</p>
				<ul className="typeset-u-list">
					<li>
						Wie kann das Unternehmen optimal auf eine Übergabe vorbereitet
						werden?
					</li>
					<li>Wer kommt als Käufer in Frage?</li>
					<li>Wie könnte eine faire Bewertung für das Lebenswerk aussehen?</li>
					<li>Wie kann der Übergabeprozess optimal gestaltet werden?</li>
				</ul>
				<p>
					Die Feingeist Beratung steht mit unseren Experten und Netzwerk gerne
					zur Verfügung, um Ihnen die optimale Strategie bei der
					Unternehmensnachfolge aufzuzeigen.
				</p>
				<p>
					Wir helfen Ihnen im Rahmen einer strukturierten Nachfolgeberatung mit
					unserem Nachfolge Check Ihr Lebenswerk bestmöglich zu übergeben, damit
					Sie sich neuen Dingen widmen können.
				</p>
				<p>Sprechen Sie uns an.</p>

				<h2 className="hd-center">Beratungsprodukte</h2>
				<div className="downloads">
					<div className="download_pdf">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/der_nachfolge_check_der_feingeist_gmbh.pdf">
							<div className="image_landscape der_nachfolge"></div>

							<div className="ebook-desc">
								<h3>Flyer Nachfolge Check</h3>
							</div>
						</a>
					</div>

					<div className="download_pdf">
						<a href="https://feingeist-beratung.de/wp-content/uploads/2023/12/ebook_next_generation.pdf">
							<div className="image_potrait ebook_next"></div>

							<div className="ebook-desc">
								<h3>Informationsbroschüre zu unserem Nachfolge Check</h3>
							</div>
						</a>
					</div>
				</div>
			</div>
		</>
	);
}
